import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SplashScreenImageModalBlockConfig } from '@front-platform/content-builder';
import {
  resolveCloseIconFieldColors,
  splashScreenImageModalBlockResolveConfig,
} from '@front-platform/content-builder';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
import { SplashScreenImageModalComponent } from '@shared/modals/splash-screen-image-modal/splash-screen-image-modal.component';
export interface SplashScreenImageModalBlockRuntimeConfig {
  'title'?: string | undefined;
}

export type SplashScreenImageModalBlockConfigInput = Partial<
  Omit<SplashScreenImageModalBlockConfig, keyof SplashScreenImageModalBlockRuntimeConfig> &
    SplashScreenImageModalBlockRuntimeConfig
>;
export type SplashScreenImageModalBlockResolvedConfig = Omit<
  SplashScreenImageModalBlockConfig,
  keyof SplashScreenImageModalBlockRuntimeConfig
> &
  Partial<SplashScreenImageModalBlockRuntimeConfig>;
export interface SplashScreenImageModalBlockContract extends ConfigComponentContract<
  SplashScreenImageModalBlockConfigInput,
  SplashScreenImageModalBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-splash-screen-image-modal-block',
  standalone: false,
})
export class SplashScreenImageModalBlockComponent
  implements OnInit, OnDestroy, SplashScreenImageModalBlockContract
{
  readonly config = input<SplashScreenImageModalBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SplashScreenImageModalBlockConfig,
    SplashScreenImageModalBlockRuntimeConfig
  >(splashScreenImageModalBlockResolveConfig, () => ({ config: this.config() }));
  get url(): string | undefined {
    return this.resolvedConfig()['url'] as unknown as string | undefined;
  }
  get title(): string | undefined {
    return this.resolvedConfig()['title'] as unknown as string | undefined;
  }
  get maxWidth(): string {
    return this.resolvedConfig()['max_width'] as unknown as string;
  }
  get maxHeight(): string {
    return this.resolvedConfig()['max_height'] as unknown as string;
  }
  get content(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['content'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get closeIconFieldColors() {
    const cfg = this.resolvedConfig() as Record<string, unknown>;
    return resolveCloseIconFieldColors(cfg, this.config() as Record<string, unknown>);
  }
  get closeDelay(): string | undefined {
    return this.resolvedConfig()['close_delay'] as unknown as string | undefined;
  }

  constructor(private modalService: ModalsService) {}

  ngOnInit(): void {
    this.modalService.open(SplashScreenImageModalComponent.handle, undefined, {
      url: this.url,
      content: this.content,
      maxWidth: this.maxWidth,
      maxHeight: this.maxHeight,
      closeDelay: this.closeDelay,
      closeIconFieldColors: this.closeIconFieldColors,
    });
  }

  ngOnDestroy(): void {
    this.modalService.close(SplashScreenImageModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SplashScreenImageModalBlockComponent, {
  'keyAliases': {},
});
